import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AdminCtx = createContext(null);

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/auth/me").then((r) => {
      const u = r.data.user || {};
      if (u.is_super_admin || u.role === "super_admin") setAdmin(u);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    const u = r.data.user || {};
    if (!u.is_super_admin && u.role !== "super_admin") {
      await api.post("/auth/logout").catch(() => {});
      throw new Error("Not a super-admin account");
    }
    setAdmin(u);
    return u;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setAdmin(null);
    window.location.href = "/admin/login";
  };
  const refresh = async () => {
    try {
      const r = await api.get("/auth/me");
      const u = r.data.user || {};
      if (u.is_super_admin || u.role === "super_admin") setAdmin(u);
      else setAdmin(null);
    } catch { setAdmin(null); }
  };

  return <AdminCtx.Provider value={{ admin, loading, login, logout, refresh }}>{children}</AdminCtx.Provider>;
}

export const useAdmin = () => useContext(AdminCtx);
